<template>
  <!-- no dropdown -->

  <section v-if="navItem && navItem.childRoutes?.length > 0">
    <!-- parent -->
    <div
      :class="route === navItem?.name?.toLowerCase() ? active : inActive"
      class="flex items-center justify-between"
      @click="openDropdownTree"
    >
      <div
        class="flex items-center p-2 text-xs rounded-md cursor-pointer gap-x-4 y-3"
      >
        <img :src="getNavIcon(navItem?.name)" class="w-5" />
        <p>{{ navItem.name }}</p>
      </div>

      <i class="pr-2 pi pi-angle-down"></i>
    </div>
    <!--  -->

    <!-- dropdown list -->

    <section
      class="text-xs"
      v-if="openDropdown && navItem?.childRoutes?.length > 0"
    >
      <div
        class="w-9/12 mx-auto ml-12"
        v-for="(nav, index) in navItem?.childRoutes"
        :key="index"
      >
        <router-link :to="{ name: nav.name }">
          <div
            class="py-2 pl-2 mb-1"
            :class="
              nav.name?.toLowerCase() === route
                ? 'bg-black text-white rounded'
                : inActive
            "
          >
            {{ nav.name }}
          </div>
        </router-link>
      </div>
    </section>
    <!--  -->
  </section>
</template>

<script>
export default {
  name: "DropdownNav",
  props: ["navItem", "getNavIcon"],
  data() {
    return {
      openDropdown: false,
      inActive: "text-black",
      route: this.$route.name?.toLowerCase(),
      active: "text-white bg-black rounded-md my-2",
    };
  },
  mounted() {
    this.checkRoute();
  },
  methods: {
    openDropdownTree() {
      this.openDropdown = !this.openDropdown;
    },
    checkRoute() {
      const isActive = this.navItem.childRoutes.some(
        (route) => route?.name?.toLowerCase() === this.route
      );

      if (isActive) {
        this.openDropdown = true;
      } else {
        this.openDropdown = false;
      }
    },
  },
};
</script>

<style></style>
